import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { withRouter, Redirect } from 'react-router'
import styled from 'styled-components'
import GoogleMapReact from 'google-map-react'
import * as _ from 'lodash'
import { StoreProps } from 'src/stores'
import WizardContainer from 'src/components/containers/wizard/WizardContainer'
import Box from 'src/components/containers/wizard/Box'
import ProgressBar, {
  ProgressBarContainerWizard
} from 'src/components/atoms/ProgressBar'
import Navigation from 'src/components/atoms/wizard/Navigation'
import Question from 'src/components/atoms/wizard/Question'
import { GoogleMapSearchBox } from 'src/components/molecules/configurator/GoogleMapSearchBox'
import FeedbackText from 'src/components/atoms/FeedbackText'

interface State {
  valid: boolean
  value: string
  inFocus: boolean
  maps: any
  apiReady: boolean
  noRedirect: boolean
}

const nudges = new Map([
  [
    'BURIAL',
    'Die Erdbestattung ist die traditionellste Form der Bestattung. Eine sehr gute Wahl.'
  ],
  [
    'CREMATION',
    'Die Feuerbestattung ist mittlerweile die beliebteste Bestattungsform. Eine sehr gute Wahl.'
  ],
  [
    'TREE_FUNERAL',
    'Immer mehr Menschen entscheiden sich für die Baumbestattung als natürliche Bestattungsform.'
  ],
  [
    'SEA_FUNERAL',
    'Eine Donaubestattung bietet einen ganz besonderen Rahmen für den Abschied.'
  ]
])

@inject('wizardStore')
@observer
export class WizardLocation extends React.Component<StoreProps, State> {
  constructor(props) {
    super(props)
    const { wizardStore } = this.props
    let preDefValue = ''
    if (wizardStore.location.zipCode)
      preDefValue = `${wizardStore.location.zipCode} `
    if (wizardStore.location.city)
      preDefValue = `${preDefValue}${wizardStore.location.city}, Österreich`
    const query = new URLSearchParams(location.search)
    this.state = {
      valid: !!wizardStore.location.city,
      value: preDefValue,
      inFocus: false,
      maps: null,
      apiReady: false,
      noRedirect: !!query.get('editor')
    }
  }

  componentDidMount() {
    window.dataLayer.push({ event: 'optimize.wizard_impendingLocation' })
  }

  componentDidUpdate() {
    window.dataLayer.push({ event: 'optimize.wizard_impendingLocation' })
  }

  decideNudge = () => {
    const { wizardStore } = this.props
    return nudges.get(wizardStore.basics.funeralType)
  }

  mapApiLoaded = ({ _map, maps }) => {
    this.setState({ maps, apiReady: true })
  }

  handleOnFocus = () => {
    const { wizardStore } = this.props
    wizardStore.location.city = null
    wizardStore.location.zipCode = null
    this.setState({ inFocus: true, valid: false, value: '' })
  }

  handleOnBlur = () => {
    this.setState({ inFocus: false })
  }

  handleChange = (location) => {
    const { wizardStore } = this.props
    const data = location.address_components
    if (data) {
      const city =
        this.extractLocationValue(data, 'locality') ||
        this.extractLocationValue(data, 'sublocality') ||
        this.extractLocationValue(data, 'administrative_area_level_1')
      const zipCode = this.extractLocationValue(data, 'postal_code')
      this.setState({ value: location.formatted_address, valid: true })
      wizardStore.location.city = city
      wizardStore.location.zipCode = zipCode
      wizardStore.location.latitude = `${location.geometry.location.lat()}`
      wizardStore.location.longitude = `${location.geometry.location.lng()}`
      wizardStore.location.label = city
    } else {
      this.setState({ value: location.target.value, valid: false })
    }
  }

  extractLocationValue = (data, key) => {
    let result = null
    data.forEach((e) => {
      if (e.types.includes(key)) {
        result = e.short_name
      }
    })
    return result
  }

  render() {
    const { wizardStore } = this.props
    const { apiReady, maps, inFocus, value, valid, noRedirect } = this.state

    if (!wizardStore.basics.planningReason && !noRedirect)
      return <Redirect to='/planung/start/' />

    return (
      <WizardContainer>
        <Box>
          <ProgressBarContainerWizard>
            <ProgressBar start={40} end={80}>
              <p>
                <i className='fas fa-check'></i>
                {this.decideNudge()}
              </p>
            </ProgressBar>
          </ProgressBarContainerWizard>
          <Question>Wo wird der Todesfall voraussichtlich eintreten?</Question>

          <GoogleMapContainer>
            <GoogleMapReact
              bootstrapURLKeys={{
                key: 'AIzaSyC1FnqfxEtPCI6h1wg5iJ9EdOqtJbv1wxY',
                region: 'at',
                language: 'de-at',
                libraries: ['places']
              }}
              yesIWantToUseGoogleMapApiInternals
              onGoogleApiLoaded={this.mapApiLoaded}
              zoom={13}
              center={{ lat: 47.41, lng: 13.06 }}></GoogleMapReact>
          </GoogleMapContainer>

          {apiReady && (
            <GoogleMapSearchBox
              value={value}
              onFocus={this.handleOnFocus}
              onBlur={this.handleOnBlur}
              googlemaps={maps}
              onChange={this.handleChange}
              searchRestrictions={{ types: ['(regions)'] }}
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                textAlign: 'center',
                display: 'block',
                width: '85%'
              }}
            />
          )}

          <FeedbackText visible={valid}>
            Hier sind wir gerne für Sie da!
          </FeedbackText>
        </Box>
        <Navigation
          next={wizardStore.nextWizardStep}
          text='Weiter'
          disabled={!valid}
          hideOnMobile={inFocus}
        />
      </WizardContainer>
    )
  }
}

const GoogleMapContainer = styled.div`
  .gm-style-pbt {
    display: none;
  }
`

export default withRouter(WizardLocation)



// WEBPACK FOOTER //
// ./src/components/organisms/wizard/impending/LocationInput.tsx